import React from 'react';
export interface CardProps {
  children: React.ReactNode;
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
  'data-id'?: string;
}
export function Card({
  children,
  hover = false,
  padding = 'md',
  className = '',
  'data-id': dataId
}: CardProps) {
  const paddingStyles = {
    none: 'p-0',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };
  return <div className={`
        bg-white rounded-lg border border-[#CBD5E1] shadow-sm
        ${hover ? 'hover:shadow-md transition-shadow duration-200' : ''}
        ${paddingStyles[padding]}
        ${className}
      `} data-id="element-5547" data-mp="1svv24qh8qr1j">
      {children}
    </div>;
}